import { render, staticRenderFns } from "./ExpandMenuIcon.vue?vue&type=template&id=39093c2c&scoped=true&"
import script from "./ExpandMenuIcon.vue?vue&type=script&lang=ts&"
export * from "./ExpandMenuIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39093c2c",
  null
  
)

export default component.exports